import React, { useState, useRef, useEffect } from "react";
import { BsThreeDots } from "react-icons/bs";
import "./optionsMenu.scss";

const OptionsMenu = ({ options }) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleToggle = () => setIsOpen((prev) => !prev);

    const handleOptionClick = (action) => {
        action.onClick();
        setIsOpen(false);
    };

    return (
        <div className="options-menu" ref={menuRef}>
            <button className="options-menu__button" onClick={handleToggle}>
                <BsThreeDots className="options-menu__button__icon" />
            </button>
            {isOpen && (
                <div className="options-menu__content">
                    {options
                        .filter((x) => x.enabled || x.enabled == null)
                        .map((option, index) => (
                            <div
                                key={index}
                                className="options-menu__content__item"
                                onClick={() => handleOptionClick(option)}
                            >
                                <div className="options-menu__content__item__icon">
                                    {option.icon}
                                </div>
                                <span className="options-menu__content__item__label">
                                    {option.label}
                                </span>
                            </div>
                        ))}
                </div>
            )}
        </div>
    );
};

export default OptionsMenu;
